import React, { useState } from 'react';
import { get, isNil } from 'lodash';
import { injectIntl, IntlShape } from 'react-intl';
import { Typography, Grid, Chip } from '@material-ui/core';
import { translate } from 'containers/services/translate';
import messages from 'containers/common/LegalProceedings/JudgementAdd/Recap/messages';
import {
  STATUS_REJECTED,
  STATUS_VALIDATED,
} from 'containers/LawyerFeeNote/constants';
import { INCOME_CERTIFICATE } from 'containers/data-structure';
import Document from 'components/Document';
import { handleOpenDocument } from 'services/utils';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import DropDownDecisionMenu from 'components/SahamDropDown/DropDownDecisionMenu';
import { INCOME_CERTIFICATE_DIALOG } from 'containers/CourtManagerLegalProceedings/JudgementAdd/constants';
import ValidationDialog from 'containers/common/LegalProceedings/JudgementAdd/Recap/IncomeCertificatesRecap/ValidationDialog';
import { COLORS } from 'constants/design';
import {
  renderColor,
  renderChipLabel,
} from 'containers/common/LegalProceedings/JudgementAdd/Recap/utils';
export interface IncomeCertificateRecapProps {
  intl: IntlShape;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  sagisVictimInfo: any;
  isManager: Boolean;
  setDocumentId?: Function;
  documentId: any;
  claimId: number;
  claimNumber: string;
  judiciaryProcessId: any;
  readOnly?: boolean;
  incomeCertificate: any;
  incomeCertificates: any;
  setIncomeCertificates: Function;
  requestUpdateIncomeCertificate?: Function;
  requestMakeDecisionIncomeCertificate?: Function;
  isConsultation?: boolean;
  riskKey: string;
  claim: any;
  judgementAdd: any;
  dahirAmount: any;
  requestGetDocByDocumentumId: Function;
}
const StyledTypography = {
  color: COLORS.LIGHT_GREY,
  fontWeight: 400,
  fontSize: '13px',
};
const StyledChip = {
  color: COLORS.WHITE,
  fontWeight: 700,
};
export const IncomeCertificateRecap: React.FC<IncomeCertificateRecapProps> = ({
  incomeCertificate,
  ...props
}): JSX.Element => {
  const [dropDown, setDropDown] = useState<null | HTMLElement>(null);

  const [isDialogOpen, setIsDialogOpen] = useState<any>({
    [INCOME_CERTIFICATE_DIALOG.VALIDATION]: false,
    [INCOME_CERTIFICATE_DIALOG.REFUSAL]: false,
  });

  const handleIsDialogOpen = (dialog: string) => () => {
    setIsDialogOpen({
      ...isDialogOpen,
      [dialog]: !get(isDialogOpen, `${dialog}`, false),
    });
  };

  const dropDownMenuElements = () => {
    return [
      {
        title: translate(messages.validateButton, props),
        action: handleIsDialogOpen(INCOME_CERTIFICATE_DIALOG.VALIDATION),
        disabled: false,
      },
      {
        title: translate(messages.rejectButton, props),
        action: handleIsDialogOpen(INCOME_CERTIFICATE_DIALOG.REFUSAL),
        disabled: false,
      },
    ];
  };
  return (
    <React.Fragment>
      <section className="item-container">
        <article className="field">
          <div className="label">{translate(messages.income, props)}</div>
          <div className="value">
            {get(incomeCertificate, INCOME_CERTIFICATE.INCOME, '')}
          </div>
        </article>
        {(!!get(incomeCertificate, INCOME_CERTIFICATE.URL) ||
          !!get(incomeCertificate, 'documentumId')) && (
          <section className="uploaded-civil-doc">
            <div className="civil-document-recap-sub-title">
              {translate(messages.documentCertificate, props)}
            </div>
            <Document
              name={get(incomeCertificate, 'name')}
              type={get(incomeCertificate, 'type')}
              icon={
                <VisibilityIcon
                  className="consult"
                  onClick={handleOpenDocument(
                    incomeCertificate,
                    props.requestGetDocByDocumentumId,
                  )}
                />
              }
            />
          </section>
        )}

        {props.isManager &&
          !props.isConsultation &&
          get(incomeCertificate, 'status') != STATUS_VALIDATED && (
            <DropDownDecisionMenu
              setDropDown={setDropDown}
              dropDown={dropDown}
              label={translate(messages.managerDecision, props)}
              menuElements={dropDownMenuElements()}
            />
          )}
      </section>
      {!isNil(get(incomeCertificate, 'status', null)) && (
        <Grid direction="row" container spacing={1}>
          <Grid item xs={3}>
            <Typography style={StyledTypography}>
              {translate(messages.statusTitle, props)}
            </Typography>
          </Grid>
          <Grid item xs={11}>
            <Chip
              style={{
                ...StyledChip,
                backgroundColor: renderColor(get(incomeCertificate, 'status')),
              }}
              label={renderChipLabel(get(incomeCertificate, 'status'))}
            />
          </Grid>
          {get(incomeCertificate, 'status') === STATUS_REJECTED && (
            <>
              <Grid item xs={11}>
                <Typography style={StyledTypography}>
                  {translate(messages.reasonTitle, props)}
                </Typography>
              </Grid>
              <Grid item xs={11}>
                <Typography>
                  {get(incomeCertificate, 'rejectionReason')}
                </Typography>
              </Grid>
            </>
          )}
        </Grid>
      )}

      <ValidationDialog
        sagisVictimInfo={props.sagisVictimInfo}
        isManager={props.isManager}
        claimNumber={props.claimNumber}
        claimId={props.claimId}
        judiciaryProcessId={props.judiciaryProcessId}
        handleClose={handleIsDialogOpen(INCOME_CERTIFICATE_DIALOG.VALIDATION)}
        incomeCertificate={incomeCertificate}
        open={isDialogOpen[INCOME_CERTIFICATE_DIALOG.VALIDATION]}
        requestUpdateIncomeCertificate={props.requestUpdateIncomeCertificate}
        status={STATUS_VALIDATED}
        requestMakeDecisionIncomeCertificate={
          props.requestMakeDecisionIncomeCertificate
        }
        riskKey={props.riskKey}
        claim={props.claim}
        judgementAdd={props.judgementAdd}
        dahirAmount={props.dahirAmount}
      />
      <ValidationDialog
        sagisVictimInfo={props.sagisVictimInfo}
        isManager={props.isManager}
        claimNumber={props.claimNumber}
        claimId={props.claimId}
        judiciaryProcessId={props.judiciaryProcessId}
        handleClose={handleIsDialogOpen(INCOME_CERTIFICATE_DIALOG.REFUSAL)}
        incomeCertificate={incomeCertificate}
        open={isDialogOpen[INCOME_CERTIFICATE_DIALOG.REFUSAL]}
        requestUpdateIncomeCertificate={props.requestUpdateIncomeCertificate}
        requestMakeDecisionIncomeCertificate={
          props.requestMakeDecisionIncomeCertificate
        }
        status={STATUS_REJECTED}
        riskKey={props.riskKey}
        claim={props.claim}
        judgementAdd={props.judgementAdd}
        dahirAmount={props.dahirAmount}
      />
    </React.Fragment>
  );
};

export default injectIntl(IncomeCertificateRecap);
